import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { Logo } from "@/components/wei/Badges";

export default function Auth({ mode }) {
  const { login, register } = useAuth();
  const nav = useNavigate(); const [params] = useSearchParams();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const join = mode === "join";

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const u = join ? await register(f.name, f.email, f.password) : await login(f.email, f.password);
      toast.success(join ? "Welcome to WEI" : `Welcome back, ${u.name}`);
      nav(params.get("next") || (["admin", "reviewer"].includes(u.role) ? "/admin" : "/dashboard"));
    } catch (e2) { setErr(errorMessage(e2)); } finally { setBusy(false); }
  };

  return (
    <main data-testid={`${mode}-page`} className="min-h-[80vh] grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-ink text-white p-14 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&q=80&auto=format&fit=crop" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative"><Logo light size="lg" /></div>
        <div className="relative"><h2 className="font-serif text-4xl font-semibold leading-tight max-w-md">Building the World’s Entertainment Record.</h2><p className="text-white/70 mt-4 max-w-sm text-sm">Join the global registry to claim profiles, apply for verification, follow rankings and access WEI intelligence.</p></div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-4" data-testid={`${mode}-form`}>
          <div className="eyebrow text-gold">{join ? "Create your account" : "Member access"}</div>
          <h1 className="font-serif text-4xl font-semibold">{join ? "Join WEI" : "Sign In"}</h1>
          {join && <input data-testid="auth-name" className="input-wei" required minLength={2} placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />}
          <input data-testid="auth-email" type="email" className="input-wei" required placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <input data-testid="auth-password" type="password" className="input-wei" required minLength={8} placeholder="Password (min. 8 characters)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
          {err && <p data-testid="auth-error" className="text-sm text-bordeaux">{err}</p>}
          <button data-testid="auth-submit" disabled={busy} className="btn-bordeaux w-full disabled:opacity-60">{busy ? "Please wait…" : join ? "Create account" : "Sign in"}</button>
          <p className="text-sm text-charcoal text-center">{join ? <>Already a member? <Link to="/signin" data-testid="switch-to-signin" className="text-bordeaux font-medium">Sign in</Link></> : <>New to WEI? <Link to="/join" data-testid="switch-to-join" className="text-bordeaux font-medium">Join WEI</Link></>}</p>
        </form>
      </div>
    </main>
  );
}
